import { useQuery } from '@tanstack/react-query';
import { graphqlRequest } from '../utils/graphqlRequest';
import { workoutInfoQuery } from '../constants/queries';
import { useToastContext } from '../components/UI/ToastManager';

type WorkoutQueryResponse = {
  workoutInfos: WorkoutInfo[];
};

type WorkoutInfo = {
  id: string;
  name: string;
  displayName: {
    language: string;
    text: string;
  };
  selector: { 
		focus: string;
  	sport: string;
  	flags: string[];
	}
	status: string;
  lastUpdatedDate?: string | Date;
};

type WorkoutVideo = {
  language: string;
  video: {
    source: string;
    title: string;
  };
};


export type WorkoutsTableItem = {
	id: string | number;
	name: string;
	focus: string;
	sport: string;
	flag: string;
	status: string;
	update: string;
};

export function useWorkoutQuery() {
  const { showError } = useToastContext();

  return useQuery<WorkoutsTableItem[]>({
    queryKey: ['workoutInfo'],
    queryFn: () =>
      graphqlRequest<WorkoutQueryResponse>(workoutInfoQuery, undefined, showError).then(({ workoutInfos }) =>
        workoutInfos.map((workout): WorkoutsTableItem => ({
					id: workout.id,
          name: workout.displayName?.text || workout.name,
          focus: workout.selector.focus,
          sport: workout.selector.sport,
          flag: workout.selector.flags?.[0] || '',
          status: workout.status,
          update: workout.lastUpdatedDate?.toString() || '23/05/2025',
        }))
      ),
  });
}